
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Api from '@gid/vue-common/api';
import { debounce } from 'lodash';

interface ProjectOption {
  id: string;
  name: string;
}

@Component
export default class ProjectSelector extends Vue {
  @Prop({ default: null }) value!: ProjectOption | null;

  options: ProjectOption[] = [];
  loading: boolean = false;
  selected: ProjectOption | null = null;

  search!: (query: string) => void;

  created() {
    if (this.value) {
      this.selected = this.value;
    }
    this.search = debounce(async (query: string) => {
      if (!query || query.length < 2) {
        this.options = [];
        return;
      }
      this.loading = true;
      try {
        const response = await Api.get(
          `/data-api/projects?s=${JSON.stringify({
            name: { $contL: query },
          })}&limit=20`,
        );
        this.options = response.data.map((p: any) => ({
          id: p.id,
          name: p.name,
        }));
      } catch (e) {
        this.options = [];
      } finally {
        this.loading = false;
      }
    }, 300);
  }

  @Watch('value')
  onValueChange(val: ProjectOption | null) {
    this.selected = val;
  }

  onSelect(val: ProjectOption | null) {
    this.$emit('input', val);
  }
}
